import { safeParseJson } from "src/handlers/Projects/schema";

export { safeParseJson };

export function sanitizeId(value) {
  return String(value).replace(/[^a-zA-Z0-9._-]/g, "_").slice(0, 36);
}

export function getStoredJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

export function normalizeDeviceIdentifier(value) {
  return String(value || "").trim().toLowerCase();
}

export function invertIp(mask = "") {
  const parts = mask.split(".").map(Number);
  if (parts.length !== 4 || parts.some(Number.isNaN)) return "";
  return parts.map((part) => 255 - part).join(".");
}

export function getNetworkId(hostAddress = "", subnetMask = "") {
  const host = hostAddress.split(".").map(Number);
  const subnet = subnetMask.split(".").map(Number);

  if (host.length !== 4 || subnet.length !== 4 || [...host, ...subnet].some(Number.isNaN)) {
    return "";
  }

  return host.map((octet, index) => octet & subnet[index]).join(".");
}

export function isIPv6(address = "") {
  return address.includes(":");
}

export function cloneData(data) {
  return structuredClone(data);
}
